<template>
  <div id="content" class="px2 sm-px3 pt0">
    <main-menu :showSub='true' class="sticky"></main-menu>

    <div class="clearfix">
      <div class="page-content sm-col-12 md-col-10 lg-col-7 mx-auto" v-if="currentPage.content">
        <h1 class="center" v-html="getText(currentPage.content.title)"></h1>
        <div class="serif" :class="{ 'subtle-links': this.$route.params.slug === 'acknowledgements' }" v-if="currentPage.content.content" v-html="getHtml(currentPage.content.content)"></div>
        <div v-if="files">
          <ul>
            <li class="mb2" v-for="(file, index) in files" :key="`file-${index}`">
              <a v-if="file.file.hasOwnProperty('url')" :href="file.file.url" target="_blank">{{ getText(file.description) }}</a>
              <a v-else-if="file.link.hasOwnProperty('url')" :href="file.link.url" target="_blank">{{ getText(file.description) }}</a>
            </li>
          </ul>
        </div>
        <div v-if="gallery">
          <gallery :images="images" :index="index" @close="index = null" :options="{vimeoClickToPlay: false}"></gallery>
          <ul class="gallery row clearfix col-12">
            <li class="col col-6 sm-col-4 px2 pointer" @click="index = 0">
              <div class="gallery-thumb"><img src="https://prismic-io.s3.amazonaws.com/ftiam%2F90dce8a7-a197-4e55-a502-9d7d3f2b544e_video-play-thumb_02.jpg" /></div>
            </li>
            <li class="col col-6 sm-col-4 px2 pointer" v-for="(item, imageIndex) in gallery" :key="imageIndex" @click="index = imageIndex + 1">
              <div class="gallery-thumb"><img v-lazy="item.image.Preview.url" /></div>
            </li>
          </ul>
        </div>
        <div v-if="this.$route.params.slug === 'press'" class="mt3">
          <a href="https://www.instagram.com/firstthereisamountain/" target="_blank">Instagram,</a>
          <a href="https://www.facebook.com/pages/category/Art/FirstthereisamountainUK/about/" target="_blank">Facebook</a>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getText, getHtml, processDate } from '@/utils'
import mainMenu from '@/components/MainMenu'
import gallery from 'vue-gallery'
import 'blueimp-gallery/js/blueimp-gallery-vimeo.js'

export default {

  name: 'Page',

  metaInfo () {
    if (this.$route.name === 'Visitor Information') {
      if (this.$route.params.slug === 'learning-resource') {
        return {
          title: 'Learning Resource'
        }
      } else {
        return {
          title: 'Visitor Information'
        }
      }
    } else if (this.$route.name === 'Gallery') {
      return {
        title: 'Gallery'
      }
    } else {
      let slugTitles = {
        artist: 'The Artist',
        press: 'Press',
        contact: 'Contact',
        acknowledgements: 'Acknowledgements',
        gallery: 'Gallery',
        'visitor-information': 'Visitor Information',
        'learning-resource': 'Learning Resource'
      }

      if (slugTitles.hasOwnProperty(this.$route.params.slug)) {
        return {
          title: slugTitles[this.$route.params.slug]
        }
      } else {
        return {
          title: 'About'
        }
      }
    }
  },

  data () {
    return {
      index: null,
      luminousGallery: null
    }
  },

  components: {
    gallery,
    mainMenu
  },

  mounted () {
    this.triggerLoad()
  },

  computed: {
    ...mapState([
      'pages'
    ]),
    slug () {
      if (this.$route.params.slug) {
        return this.$route.params.slug
      } else {
        return this.$route.path.replace('/','')
      }
    },
    currentPage () {
      return this.pages[this.slug]
    },
    files () {
      return this.currentPage.content.files
    },
    images () {
      var galleryItems = this.currentPage.content.gallery.map(x => {
        return {
          title: this.getText(x['caption']),
          href: x.image.url,
          type: 'image/jpeg',
          poster: x.image.url
        }
      })
      galleryItems.unshift({
        title: 'First There is a Mountain Film (SUBTITLED)',
        href: 'https://vimeo.com/316766748',
        type: 'text/html',
        vimeo: '316766748',
        poster: 'https://prismic-io.s3.amazonaws.com/ftiam%2F635d7fe6-e8a0-4957-ad18-7b9293edeeef_vimeo-image-play.jpg'
      })
      return galleryItems
    },
    gallery () {
      return this.currentPage.content.gallery
    }
  },

  methods: {
    getText,
    getHtml,
    processDate,
    ...mapActions([
      'loadPage'
    ]),
    triggerLoad () {
      this.loadPage(this.slug)
    }
  },

  watch: {
    '$route' () {
      this.loadPage(this.slug)
    }
  }
}
</script>

<style lang="css" scoped>
  .page-content {
    margin-top: 10vh;

    h1 {
      font-size: 42px;
      margin-bottom: 10vh;
    }

    .subtle-links >>> a {
      border: none;
    }

    & >>> a {
      border-bottom: 1px solid var(--green);
    }

    & >>> h3 {
      margin-top: 4em;
      padding-top: 0;
      font-family: var(--font-sans);
      border-bottom: 1px solid var(--black);
      padding-bottom: 1em;

      &:first-child {
        margin-top: 0;
      }
    }

    & >>> p.block-img img {
      width: 80%;
      display: block;
      margin: 0 auto;
    }

    & >>> ul {
      list-style: none;
      padding: 0;

      li {
        margin-top: 0.25em;
      }
    }
  }

  .gallery-thumb {
    position: relative;
    width: 100%;
    margin-bottom: 1em;
  }

  .gallery-thumb:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }

  .gallery-thumb img {
    position: absolute;
    margin-left: 1%;
    width: 98%;
    height: 98%;
  }
</style>
